"use client";

import { useEffect, useState } from "react";
import { Image, Box, useColorModeValue, Skeleton, Tooltip } from "@chakra-ui/react";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../tools/firebase";
import { useSupplierRetailer } from "../wrappers/SupplierRetailerContext";

const SupplierLogo = () => {
  const { selectedSupplier } = useSupplierRetailer();
  const [logoUrl, setLogoUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Color mode values
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  /*
  useEffect(() => {
    const fetchLogo = async () => {
      setIsLoading(true)
      if (!selectedSupplier) {
        setIsLoading(false)
        return
      }

      const logoRef = ref(storage, `logos/${selectedSupplier}.jpg`)
      try {
        const url = await getDownloadURL(logoRef)
        setLogoUrl(url)
      } catch (error) {
        console.error("Error fetching logo:", error)
        const defaultLogoRef = ref(storage, `logos/blank.jpg`)
        try {
          const defaultUrl = await getDownloadURL(defaultLogoRef)
          setLogoUrl(defaultUrl)
        } catch (defaultError) {
          console.error("Error fetching default logo:", defaultError)
        }
      } finally {
        setIsLoading(false)
      }
    }

    fetchLogo()
  }, [selectedSupplier])
*/

  useEffect(() => {
    setIsLoading(true);
    if (!selectedSupplier) {
      setLogoUrl(null);
      setIsLoading(false);
      return;
    }
    const ext = selectedSupplier === 'DEMO' ? 'png' : 'jpg';
    setLogoUrl(`/${selectedSupplier}.${ext}`);
    setIsLoading(false);
  }, [selectedSupplier]);

  return (
    <Tooltip label={selectedSupplier || "No supplier selected"} placement="left" hasArrow>
      <Box
        position="fixed"
        top="10px"
        right="20px"
        zIndex={3000}
        boxShadow="lg"
        borderRadius="full"
        bg={bgColor}
        p={2}
        border="1px solid"
        borderColor={borderColor}
        transition="all 0.3s ease"
        _hover={{
          transform: "scale(1.05)",
          boxShadow: "xl",
        }}
      >
        {isLoading ? (
          <Skeleton height="60px" width="60px" borderRadius="full" />
        ) : (
          logoUrl && (
            <Image
              boxSize="60px"
              objectFit="contain"
              src={logoUrl || "/blank.jpg"}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "/blank.jpg";
              }}
              alt={`${selectedSupplier} logo`}
              borderRadius="full"
              transition="all 0.3s ease"
            />
          )
        )}
      </Box>
    </Tooltip>
  );
};

export default SupplierLogo;
